export default "__VITE_ASSET__BmhOUxQV__"